#include <worldpos_vertex>

vWorldPosition = worldPosition.xyz;